import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as o } from "./tslib.es6.js";
import r from "../Color.js";
import { JSONSupport as s } from "../core/JSONSupport.js";
import { clone as e } from "../core/lang.js";
import { property as t } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as p } from "../core/accessorSupport/decorators/subclass.js";
import { colorAndTransparencyProperty as c } from "../symbols/support/materialUtils.js";

var _l;

var a = _l = /*#__PURE__*/function (_s) {
  _inherits(l, _s);

  var _super = _createSuper(l);

  function l() {
    var _this;

    _classCallCheck(this, l);

    _this = _super.apply(this, arguments), _this.color = new r("white");
    return _this;
  }

  _createClass(l, [{
    key: "clone",
    value: function clone() {
      return new _l({
        color: e(this.color)
      });
    }
  }]);

  return l;
}(s);

o([t(c)], a.prototype, "color", void 0), a = _l = o([p("esri.symbols.callouts.LineCallout3DBorder")], a);
var i = a,
    m = Object.freeze({
  __proto__: null,

  get LineCallout3DBorder() {
    return a;
  },

  default: i
});
export { m as L, i as a, a as b };